<template>
  <SpPage :title="id ? '予約変更' : '新規予約'" showBack @back="back">
    <ReserveDiff class="detail" :after="after" :before="id && before" />

    <template #footer>
      <Button @click="back">戻る</Button>
      <Button primary @click="save">確定</Button>
    </template>
    <CouponWarningModal
      v-if="couponWarningModal"
      :isOverEndTime="isOverEndTime"
      :syncType="reserve.syncType"
      @onConfirm="goTo()"
      @onClose="couponWarningModal = false"
    />
  </SpPage>
</template>

<script>
import { get, isEqual } from 'lodash'
import { addMinutes, isAfter } from 'date-fns'
import { mapState, mapGetters } from 'vuex'
import { toHourClock, toDate } from '@/utils/date'
import { padZero } from '@/utils/number'
import SpPage from '@/components/templates/SpPage'
import ReserveDiff from '@/components/molecules/ReserveDiff'
import CouponWarningModal from '@/components/organisms/CouponWarningModal'
import Button from '@/components/atoms/Button'

export default {
  components: {
    SpPage,
    ReserveDiff,
    CouponWarningModal,
    Button,
  },
  props: {
    id: Number,
    backTo: String,
  },
  data() {
    return {
      couponWarningModal: false,
    }
  },
  computed: {
    ...mapState({
      edit: state => state.reserves.edit,
      staffs: state => state.staffs,
      currentStore: state => state.stores.current.store,
      isValid: state => state.gnavi.isValid,
    }),
    ...mapGetters({
      reserve: 'reserves/edit/reserve',
    }),
    after() {
      const { receiptDatetime, reserveDatetime, courses, ...reserve } = this.reserve
      return {
        ...reserve,
        status: this.id ? 2 : 1,
        courses: courses.filter(v => v.id),
        reserveDatetime: toHourClock(reserveDatetime),
        inputBy: this.staffs.byId[this.edit.staffId].name,
      }
    },
    before() {
      const { receiptDatetime, reserveDatetime, ...reserve } = this.edit.detail.reservation
      return { ...reserve, reserveDatetime: toHourClock(reserveDatetime) }
    },
    isOverEndTime() {
      return isAfter(new Date(), addMinutes(toDate(this.after.reserveDatetime), this.after.utilizationTime))
    },
  },
  methods: {
    async save() {
      if (this.edit.reservation.coupon?.text) {
        const { id, adults, children, reserveDatetime, courses } = this.edit.reservation
        const { day, minute, hour, month, year } = toHourClock(reserveDatetime)
        await this.$store.dispatch('gnavi/checkValid', {
          storeId: this.currentStore.id,
          rsvId: id,
          persons: adults + children,
          calendarDate: '' + year + padZero(month) + padZero(day),
          startTime: '' + padZero(hour) + padZero(minute),
          courseId: courses.length ? courses[0].id : null,
        })
        if (!this.isValid) {
          this.couponWarningModal = true
          return
        }
      }
      this.goTo()
    },
    back() {
      this.$router.back()
    },
    async goTo() {
      const id = await this.$store.dispatch('reserves/edit/save')
      return id
        ? this.$router.push({ name: 'ReserveEditComplete', params: { id }, query: { backTo: this.backTo } })
        : false
    },
    diff(target) {
      return this.before && !isEqual(get(this.before, target), get(this.after, target))
    },
  },
}
</script>

<style lang="postcss" scoped>
.detail {
  margin: 16px 0;
}
</style>
